import { render, staticRenderFns } from "./TestConnection.vue?vue&type=template&id=0b44f276&"
import script from "./TestConnection.vue?vue&type=script&lang=js&"
export * from "./TestConnection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports